import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import {LocalStorageService} from 'ngx-webstorage';
import {Router} from '@angular/router';

@Injectable()
export class InterceptorClass implements HttpInterceptor {
  user: any = {};
  constructor(private localSt: LocalStorageService,
              protected router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let addAuthorization = true;
    if (!navigator.onLine) {
      this.router.navigate(['/no-internet']);
    }
    // tslint:disable-next-line:max-line-length
    if (request.url.includes('https://us-street.api.smartystreets.com') || request.url.includes('https://us-autocomplete.api.smartystreets.com')) {
      addAuthorization = false;
    }
    this.user = this.localSt.retrieve('zenUser');
    if (addAuthorization === true) {
      request = request.clone({
        setHeaders: {
          Authorization: this.user ? this.user.token : '',
        },
      });
    }
    return next.handle(request).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
      }
    }, (err: any) => {
      // console.log('err: ', err);
      if (err instanceof HttpErrorResponse) {
        if (err.status === 404 || err.status === 401) {
          this.localSt.clear('zenUser');
          this.router.navigate(['/']);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptor/httpInterceptor.ts